const ja = require('./ja');
module.exports = { ja };
